export const designTokens = {
  colors: {
    primary: '#2563EB',
    primaryDark: '#1D4ED8',
    primaryLight: '#DBEAFE',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    background: '#F8FAFC',
    surface: '#FFFFFF',
    text: '#1E293B',
    textMuted: '#64748B',
    border: '#E2E8F0',
  },
  rag: {
    green: '#10B981',
    amber: '#F59E0B',
    red: '#EF4444',
  },
  spacing: {
    pageGutter: '24px',
    cardPadding: '16px',
    sectionGap: '24px',
  },
  borderRadius: {
    card: '8px',
    button: '6px',
    input: '6px',
  },
  shadows: {
    card: '0 1px 3px rgba(0, 0, 0, 0.1)',
    dropdown: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
} as const;

export type DesignTokens = typeof designTokens;

export type RAGStatus = 'green' | 'amber' | 'red';

export function getRAGStatus(percentage: number): RAGStatus {
  if (percentage >= 80) return 'green';
  if (percentage >= 60) return 'amber';
  return 'red';
}

export function getRAGColor(status: RAGStatus): string {
  return designTokens.rag[status];
}
